import { useEffect, useState } from 'react';
import { FaArrowLeft, FaArrowRight, FaCog, FaPause, FaPlay } from 'react-icons/fa';
import { NavLink, Route, Routes, useLocation } from 'react-router-dom';

import './App.css';
import FixturesScreen from './screens/FixturesScreen';
import LeaguesRedirectScreen from './screens/LeaguesRedirectScreen';
import LeaguesScreen from './screens/LeaguesScreen';
import LiveScreen from './screens/LiveScreen';
import SettingsScreen from './screens/SettingsScreen';
import TeamsScreen from './screens/TeamsScreen';

function App() {
  const [isPaused, setIsPaused] = useState(false);
  const [manualNav, setManualNav] = useState(null);
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === '/live') {
      setIsPaused(false);
    }
  }, [location.pathname]);

  return (
    <div>
      <header>
        <nav>
          <img src="/football_and_fun.png" alt="logo" className="floating-logo" />
          <ul>
            <li>
              <NavLink to="/" end className={({ isActive }) => isActive ? 'active' : ''}>
                Leagues
              </NavLink>
            </li>
            <li>
              <NavLink to="/teams" className={({ isActive }) => isActive ? 'active' : ''}>
                Teams
              </NavLink>
            </li>
            <li>
              <NavLink to="/fixtures" className={({ isActive }) => isActive ? 'active' : ''}>
                Fixtures
              </NavLink>
            </li>
            <li>
              <NavLink to="/live" className={({ isActive }) => isActive ? 'active' : ''}>
                Live
              </NavLink>
            </li>
            {location.pathname === '/live' && (
              <li className="live-nav-controls">
                <button onClick={() => setManualNav('prev')} className="icon-btn">
                  <FaArrowLeft />
                </button>
                <button onClick={() => setIsPaused(!isPaused)} className={`icon-btn ${isPaused ? 'play-button-active' : ''}`}>
                  {isPaused ? <FaPlay /> : <FaPause />}
                </button>
                <button onClick={() => setManualNav('next')} className="icon-btn">
                  <FaArrowRight />
                </button>
              </li>
            )}
            <li className="settings-icon">
              <NavLink to="/settings" className={({ isActive }) => isActive ? 'active' : ''}>
                <FaCog />
              </NavLink>
            </li>
          </ul>
        </nav>
      </header>
      <main>
        <div className="container">
          <Routes>
            <Route path="/teams" element={<TeamsScreen />} />
            <Route path="/fixtures" element={<FixturesScreen />} />
            <Route path="/live" element={<LiveScreen isPaused={isPaused} manualNav={manualNav} setManualNav={setManualNav} />} />
            <Route path="/settings" element={<SettingsScreen />} />
            <Route path="/leagues/:ownerId" element={<LeaguesRedirectScreen />} />
            <Route path="/" element={<LeaguesScreen />} />
          </Routes>
        </div>
      </main>
    </div>
  );
}

export default App;
